import { handleApi } from "../../common";
export const ADD_FUNDS_PAYMENTS_CONSTANT = {
    'paymentLanding': '/api/equity/api/eqm/eqpayments/s2s/start/payment',
    'bankDetails': '/api/equity/api/eqm/eqpayments/bank/details',
}


export const fetch_addFunds_payment_landing = async (Api, params) => {
    const response = await Api.post(ADD_FUNDS_PAYMENTS_CONSTANT.paymentLanding, params)
    return handleApi(response)
}

export const initiate_payment = async (Api, url ,params) => {
    const response = await Api.get(url, params);
    return handleApi(response);
}

export const initiate_addfunds_payment = async (Api, url ,params) => {
    const response = await Api.get(url, params);
    return handleApi(response);
}

export const fetch_addfunds_bank = async (Api) => {
    const response = await Api.get(ADD_FUNDS_PAYMENTS_CONSTANT.bankDetails);
    return handleApi(response);
}

export const fetch_polling_status = async (Api, url) => {
    const response = await Api.get(url);
    return handleApi(response);
}

export const cancel_payment = async (Api, url) => {
    const response = await Api.post(url);
    return handleApi(response);
}

